// vista#788: an alert raised more than this long ago is STANDING, not news.
// Prod on 2026-11-02 read "59 Critical" while the network scored 93.6: 54 of
// the 58 `Device Down` alerts named devices nobody had heard from in over a
// week (40 in over a month) — departed CPE, still correctly down, still
// active. Counted as one number, a standing backlog reads as a live outage and
// buries the one that started this morning. The headline counts what is new;
// the standing ones are still counted, under it, and the card still links to
// all of them — nothing is hidden, it is ordered.
//
// Keep equal to the agent's `GONE_AFTER_SECS` (crates/processing/src/
// health_scorer.rs): an unmanaged device unseen that long also leaves the
// health average (#1001). If the two drift, "standing" and "no longer counted
// in health" stop meaning the same week. Nothing enforces this across the two
// components (#1001 review F2).
export const STANDING_AFTER_DAYS = 7;
export const STANDING_AFTER_MS = STANDING_AFTER_DAYS * 24 * 60 * 60 * 1000;

// The card's label is built from the same constant, so the text cannot
// claim "> 7d" while the threshold says something else (#998 review R1).
export const STANDING_LABEL = `standing > ${STANDING_AFTER_DAYS}d`;

// An alert with no parseable `triggered_at` counts as NEW: we cannot show it is
// old, and the error to avoid is demoting a live problem.
export function isStanding(alert, now = Date.now()) {
  const t = Date.parse(alert?.triggered_at);
  return Number.isFinite(t) && now - t > STANDING_AFTER_MS;
}
